import { KLUCZE_PROCEDUR, KLUCZE_USTAWIEN_PROCEDUR } from "../../config/obszary/kluczeProcedur";
import { zapamietajAutomat, zapamietajListe, zapamietajMacierz, zapamietajUstawienia, pozycjeListy } from "./pamiecStartu";
import { czekaNaMnie, dataKrotka, odmiana, slowoProcedura } from "../../components/Polityki/strona/etapy";
import { CZESC_KROKU } from "../../components/Polityki/karta/krokiKarty";
import { normalizujMacierz } from "../../components/Polityki/strona/macierz";

/**
 * [ui1006, paczka PROC, projekt 4.2] ŹRÓDŁA STARTU „Do załatwienia” — CZTERY odczyty (sufit `sufitOdczytowStartu: 4`):
 *   • `lista`      — `GET /polityki`: procedury czekające na mój krok (9 kodów kroku z serwera), zatwierdzone a nieopublikowane,
 *                    przegląd treści i kontrole po terminie, zaległe potwierdzenia; odpowiedź trafia do pamięci listy;
 *   • `macierz`    — `GET /polityki/obszary/macierz`: braki procedur wymaganych przez ustawę (sklejone w jeden wiersz);
 *   • `automat`    — `GET /polityki/automat`: bez wierszy — tryb powiadomień do kafla nagłówka i bloku „Stan”;
 *   • `ustawienia` — `GET /polityki/ustawienia` (klucz redakcji albo ustawień): zarząd spółki bez głosujących („Zobacz skład →”).
 * Woła je POWŁOKA (`useZrodlaStartu`), nigdy miejsce (N-12). Klient API ładowany leniwie, żeby rejestr (czytany też przez
 * zapadki tras) nie ciągnął warstwy HTTP. Wiersz: `{ id, ton, co, dlaczego, przycisk: { etykieta, adres }, obszar, rodzaj, sklejone(n) }`
 * — każdy prowadzi od razu na obiekt i część, której dotyczy (Z-18).
 */
const api = () => import("../../api/apiService").then((m) => m.default);

const adresKarty = (p, czesc, dodatkowe = {}) => {
    const q = new URLSearchParams({ doc: String(p.id) });
    const krok = CZESC_KROKU[(p.nastepnyKrok && p.nastepnyKrok.kod) || ""] || null;
    const etap = czesc ? czesc.etap : (krok ? krok.etap : (p.etapNumer || 1));
    const kod = czesc ? czesc.czesc : (krok ? krok.czesc : "");
    q.set("etap", String(etap));
    if (kod) q.set("czesc", kod);
    Object.entries(dodatkowe).forEach(([k, v]) => { if (v != null && v !== "") q.set(k, String(v)); });
    return `./procedury?${q.toString()}`;
};

const ETYKIETA_PRZEJSCIA = {
    dokoncz_tresc: "treści", wyslij_do_zatwierdzenia: "wysłania", popraw_tresc: "wersji", wyslij_do_recenzenta: "recenzji",
    wyslij_do_zarzadu: "głosowania", opublikuj: "publikacji", zobacz_potwierdzenia: "potwierdzeń", zrob_przeglad: "przeglądu", zapisz_wynik_kontroli: "kontroli",
};

const nazwa = (p) => `${p.title || "Procedura"}${p.companyNazwa ? ` — ${p.companyNazwa}` : ""}`;

export const ZRODLO_LISTA = {
    id: "lista",
    nazwa: "lista procedur",
    klucz: KLUCZE_PROCEDUR,
    pobierz: () => api().then((a) => a.getPolityki()).then((r) => { const dane = (r && r.data) || []; zapamietajListe(dane); return dane; }),
    naWiersze: (dane) => {
        const pozycje = pozycjeListy(dane).filter((p) => p.stanPolityki !== "wycofana");
        const moje = pozycje.filter((p) => czekaNaMnie(p) && p.nastepnyKrok && p.nastepnyKrok.kod && p.nastepnyKrok.kod !== "brak");
        const doPublikacji = pozycje.filter((p) => !czekaNaMnie(p) && p.nastepnyKrok && p.nastepnyKrok.kod === "opublikuj");
        const przegladPoTerminie = pozycje.filter((p) => p.przegladPoTerminie);
        const kontrolePoTerminie = pozycje.filter((p) => Number(p.kontroliPoTerminie) > 0);
        const zalegle = pozycje.filter((p) => Number(p.zalegleObowiazki) > 0);
        const wiersze = [
            ...moje.map((p) => ({
                id: `moj-krok:${p.id}`,
                ton: "pilne",
                plakietka: "czeka na Ciebie",
                co: nazwa(p),
                dlaczego: `Etap ${p.etapNumer || 1} z 4: ${p.nastepnyKrok.opis || p.nastepnyKrok.etykieta}.${p.czekaNaTermin ? ` Termin do ${dataKrotka(p.czekaNaTermin)}.` : ""}`,
                przycisk: { etykieta: `Przejdź do ${ETYKIETA_PRZEJSCIA[p.nastepnyKrok.kod] || "procedury"} →`, adres: adresKarty(p) },
                obszar: "procedury",
                rodzaj: "moj-krok",
                sklejone: (n) => ({ co: `${n} ${odmiana(n, "procedura czeka", "procedury czekają", "procedur czeka")} na Twój krok`, dlaczego: "Każda ma następny krok do wykonania przez Ciebie.", przycisk: { etykieta: "Otwórz procedury →", adres: "./procedury?widok=czekaja-na-mnie" } }),
            })),
            ...doPublikacji.map((p) => ({
                id: `do-publikacji:${p.id}`,
                ton: "pilne",
                plakietka: "zatwierdzona",
                co: nazwa(p),
                dlaczego: "Zarząd zatwierdził treść, a procedura jeszcze nie obowiązuje.",
                przycisk: { etykieta: "Przejdź do publikacji →", adres: adresKarty(p, { etap: 3, czesc: "publikacja" }) },
                obszar: "procedury",
                rodzaj: "do-publikacji",
                sklejone: (n) => ({ co: `${n} ${odmiana(n, "procedura zatwierdzona", "procedury zatwierdzone", "procedur zatwierdzonych")}, jeszcze nieopublikowanych`, dlaczego: "Każda czeka na publikację.", przycisk: { etykieta: "Otwórz procedury →", adres: "./procedury?filtrEtap=3" } }),
            })),
            ...przegladPoTerminie.map((p) => ({
                id: `przeglad:${p.id}`,
                ton: "po-terminie",
                plakietka: "po terminie",
                co: nazwa(p),
                dlaczego: `Przegląd treści minął${p.nastepnyPrzegladDo ? ` ${dataKrotka(p.nastepnyPrzegladDo)}` : ""} — nikt nie potwierdził, że treść jest aktualna.`,
                przycisk: { etykieta: "Przejdź do przeglądu →", adres: adresKarty(p, { etap: 4, czesc: "przeglady" }) },
                obszar: "procedury",
                rodzaj: "przeglad-po-terminie",
                sklejone: (n) => ({ co: `${n} ${slowoProcedura(n)} z przeglądem treści po terminie`, dlaczego: "Każda czeka na odpowiedź, czy treść jest aktualna.", przycisk: { etykieta: "Otwórz procedury →", adres: "./procedury?filtrEtap=4" } }),
            })),
            ...kontrolePoTerminie.map((p) => ({
                id: `kontrola:${p.id}`,
                ton: "po-terminie",
                plakietka: "po terminie",
                co: nazwa(p),
                dlaczego: `${p.kontroliPoTerminie} ${odmiana(p.kontroliPoTerminie, "kontrola przestrzegania czeka", "kontrole przestrzegania czekają", "kontroli przestrzegania czeka")} na wynik po terminie.`,
                przycisk: { etykieta: "Przejdź do kontroli →", adres: adresKarty(p, { etap: 4, czesc: "kontrole" }) },
                obszar: "procedury",
                rodzaj: "kontrola-po-terminie",
                sklejone: (n) => ({ co: `${n} ${slowoProcedura(n)} z kontrolą po terminie`, dlaczego: "Każda ma kontrolę przestrzegania bez zapisanego wyniku.", przycisk: { etykieta: "Otwórz procedury →", adres: "./procedury?filtrEtap=4" } }),
            })),
            ...zalegle.map((p) => ({
                id: `zalegle:${p.id}`,
                ton: "po-terminie",
                plakietka: `${p.zalegleObowiazki} ${odmiana(p.zalegleObowiazki, "osoba", "osoby", "osób")}`,
                co: `${nazwa(p)} — ${p.zalegleObowiazki} ${odmiana(p.zalegleObowiazki, "osoba nie potwierdziła", "osoby nie potwierdziły", "osób nie potwierdziło")}`,
                dlaczego: "Termin na potwierdzenie zapoznania minął.",
                przycisk: { etykieta: "Zobacz spóźnionych →", adres: adresKarty(p, { etap: 3, czesc: "potwierdzenia" }, { pokaz: "spoznieni" }) },
                obszar: "procedury",
                rodzaj: "zalegle-potwierdzenia",
                sklejone: (n) => ({ co: `${n} ${slowoProcedura(n)} z zaległymi potwierdzeniami`, dlaczego: "W każdej ktoś nie potwierdził w terminie.", przycisk: { etykieta: "Otwórz procedury →", adres: "./procedury" } }),
            })),
        ];
        return { wiersze, liczniki: { procedury: moje.length } };
    },
};

export const ZRODLO_MACIERZ = {
    id: "macierz",
    nazwa: "czego brakuje",
    klucz: KLUCZE_PROCEDUR,
    pobierz: () => api().then((a) => a.getPolitykiMacierzObszarow()).then((r) => { const dane = normalizujMacierz((r && r.data) || {}); zapamietajMacierz(dane); return dane; }),
    naWiersze: (macierz) => {
        const ustawowe = (macierz.obszary || []).filter((o) => o.grupa === "nis2");
        let braki = 0;
        const spolkiZBrakiem = new Set();
        ustawowe.forEach((o) => (macierz.spolki || []).forEach((c) => {
            const k = o.komorki.get(c.id);
            if (!k || k.stan === "brak") { braki += 1; spolkiZBrakiem.add(c.id); }
        }));
        const wiersze = braki > 0 ? [{
            id: "braki-ustawa",
            ton: "do-przejrzenia",
            plakietka: "braki",
            co: `Brakuje ${braki} ${slowoProcedura(braki)} wymaganych przez ustawę w ${spolkiZBrakiem.size} ${odmiana(spolkiZBrakiem.size, "spółce", "spółkach", "spółkach")}`,
            dlaczego: "Każdy obszar ustawy powinien mieć w każdej spółce obowiązującą procedurę.",
            przycisk: { etykieta: "Zobacz braki →", adres: "./czego-brakuje?braki=1" },
            obszar: "czego-brakuje",
            rodzaj: "braki-ustawa",
            odkladalny: true,
        }] : [];
        return { wiersze, liczniki: { "czego-brakuje": braki } };
    },
};

export const ZRODLO_AUTOMAT = {
    id: "automat",
    nazwa: "powiadomienia pracowników",
    klucz: KLUCZE_PROCEDUR,
    pobierz: () => api().then((a) => a.getPolitykiAutomat()).then((r) => { const dane = (r && r.data) || null; zapamietajAutomat(dane); return dane; }),
    naWiersze: () => ({ wiersze: [], liczniki: {} }),
};

export const ZRODLO_USTAWIENIA = {
    id: "ustawienia",
    nazwa: "ustawienia modułu",
    klucz: KLUCZE_USTAWIEN_PROCEDUR,
    pobierz: () => api().then((a) => a.getPolitykiUstawienia()).then((r) => { const dane = Array.isArray(r && r.data) ? r.data : []; zapamietajUstawienia(dane); return dane; }),
    naWiersze: (ustawienia) => {
        const bezGlosujacych = ustawienia.filter((u) => u && u.czlonkowZarzadu === 0);
        const wiersze = bezGlosujacych.map((u) => {
            const nazwaSpolki = String(u.etykieta || "").split(" — ").slice(1).join(" — ") || `spółka nr ${u.companyId}`;
            return {
                id: `bez-skladu:${u.companyId}`,
                ton: "po-terminie",
                plakietka: "głosowanie nie ruszy",
                co: `${nazwaSpolki} — zarząd bez głosujących`,
                dlaczego: "Spółka nie ma w systemie członków zarządu, więc żadnej procedury nie da się zatwierdzić.",
                przycisk: { etykieta: "Zobacz skład →", adres: "./ustawienia/zarzad" },
                obszar: "ustawienia-zarzad",
                rodzaj: "zarzad-bez-skladu",
                sklejone: (n) => ({ co: `${n} ${odmiana(n, "spółka", "spółki", "spółek")} z zarządem bez głosujących`, dlaczego: "W tych spółkach głosowanie zarządu nie ruszy.", przycisk: { etykieta: "Zobacz skład →", adres: "./ustawienia/zarzad" } }),
            };
        });
        return { wiersze, liczniki: {} };
    },
};

export const ZRODLA_STARTU_PROCEDUR = [ZRODLO_LISTA, ZRODLO_MACIERZ, ZRODLO_AUTOMAT, ZRODLO_USTAWIENIA];

export default ZRODLA_STARTU_PROCEDUR;
